import { render, staticRenderFns } from "./SelfUser.vue?vue&type=template&id=f88f3ac2&"
import script from "./SelfUser.vue?vue&type=script&lang=js&"
export * from "./SelfUser.vue?vue&type=script&lang=js&"
import style0 from "./SelfUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports